// src/pages/Users.jsx
import React, { useState, useEffect } from "react";
import API from "../api/api";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
const [mobileError, setMobileError] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [role, setRole] = useState("user");
  const [mobile_numbers, setmobile_numbers] = useState("");
  const [password, setPassword] = useState(""); // for creating/updating password
  const [editingUser, setEditingUser] = useState(null);
  const [search, setSearch] = useState("");

  const [showPassword, setShowPassword] = useState({}); // { userId: true/false }

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await API.get("/account/?page=1&limit=10");
      setUsers(res.data.rows || []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter(u =>
    u.username.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase()) ||
    u.full_name.toLowerCase().includes(search.toLowerCase())
  );

  const togglePassword = (id) => {
    setShowPassword(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { username, email, full_name: fullName, role, status: "active", mobile_numbers };
      if (password) payload.password = password; // only send password if provided

      if (editingUser) {
        await API.put(`/account/${editingUser.id}`, payload);
        alert("User updated successfully");
      } else {
        await API.post("/account/create", { ...payload, password: password || "Default@123" });
        alert("User created successfully");
      }

      // reset form
      setUsername(""); setEmail(""); setFullName(""); setRole("user"); 
      setmobile_numbers(""); setPassword(""); setEditingUser(null);
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert("Failed to save user");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this user?")) return;
    try { await API.delete(`/account/${id}`); fetchUsers(); } catch { alert("Failed to delete user"); }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setUsername(user.username);
    setEmail(user.email);
    setFullName(user.full_name);
    setRole(user.role);
    setmobile_numbers(user.mobile_number || "");
    setPassword(""); // leave password blank, update only if user types a new one
  };

  return (
    <div className="container-fluid p-3">
      <h3 className="mb-3">Users Management</h3>

      {/* Search */}
      <div className="d-flex mb-2 flex-column flex-md-row gap-2">
        <input type="text" className="form-control" placeholder="Search users..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {/* User Form */}
      <div className="card mb-3">
        <div className="card-body">
          <h5>{editingUser ? "Edit User" : "Create User"}</h5>
          <form onSubmit={handleSubmit} className="row g-2">
            <div className="col-md-2"><input className="form-control" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} required/></div>
            <div className="col-md-2"><input className="form-control" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required/></div>
            <div className="col-md-2"><input className="form-control" placeholder="Full Name" value={fullName} onChange={e => setFullName(e.target.value)} required/></div>
            <div className="col-md-2">
              <select className="form-select" value={role} onChange={e => setRole(e.target.value)}>
                <option value="it_admin">IT Admin</option>
                <option value="admin">Admin</option>
                <option value="user">User</option>
                <option value="agent">Agent</option>
              </select>
            </div>
            
            <div className="col-md-2">
  <input
    type="text"
    className={`form-control ${mobileError ? "is-invalid" : ""}`}
    placeholder="Mobile Number"
    value={mobile_numbers}
    maxLength={11}
    onChange={(e) => {
      let value = e.target.value;

      // allow only numbers
      if (!/^\d*$/.test(value)) return;

      setmobile_numbers(value);

      if (value.length === 0) {
        setMobileError("");
      }
      else if (!value.startsWith("03")) {
        setMobileError("Mobile number must start with 03");
      }
      else if (value.length !== 11) {
        setMobileError("Mobile number must be 11 digits");
      }
      else {
        setMobileError("");
      }
    }}
  />

  {mobileError && (
    <div className="invalid-feedback">
      {mobileError}
    </div>
  )}
</div>


            <div className="col-md-2"><input className="form-control" placeholder="Password(leave blank to keep)" value={password} onChange={e => setPassword(e.target.value)} /></div>
           
            <div className="col-md-12 mt-2">
              <button className="btn btn-primary w-100" type="submit">{editingUser ? "Update" : "Create"}</button>
            </div>
          </form>
        </div>
      </div>

      {/* Users Table */}
      {loading ? <p>Loading...</p> : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered align-middle">
            <thead className="table-dark">
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Email</th>
                <th>Full Name</th>
                <th>Role</th>
                <th>Status</th>
                <th>Mobile Numbers</th>
                {/* <th>Password</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(u => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.username}</td>
                  <td>{u.email}</td>
                  <td>{u.full_name}</td>
                  <td>{u.role}</td>
                  <td>{u.status}</td>
                  <td>{u.mobile_number}</td>
                  {/* <td>
                    {showPassword[u.id] ? u.password_hash : "••••••••••"}{" "}
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => togglePassword(u.id)}>
                      {showPassword[u.id] ? "Hide" : "Show"}
                    </button>
                  </td> */}
                  <td className="d-flex gap-1">
                    <button className="btn btn-sm btn-warning" onClick={() => handleEdit(u)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(u.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}